import React, { useContext, useEffect } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import StatusMessage, { useStatusMessage } from '../../../ui/StatusMessage/StatusMessage'
import useCampaignLinksSubscription from '../../../api/marketing/useCampaignLinksSubscription'
import UtmBuilder from '../UtmBuilder/UtmBuilder'
import LinksTable from './LinksTable'
import { AuthContext } from '../../../App'

function MarketingLinks({ history, match }) {
  const { user } = useContext(AuthContext)
  const [statusMessage, setStatusMessage] = useStatusMessage()
  const { links, isLoading, error } = useCampaignLinksSubscription(user?.uid)

  useEffect(() => {
    if (!error) {
      return
    }

    setStatusMessage({
      show: true,
      type: 'fail',
      message: error,
      closeAfter: 6000,
    })
  }, [error, setStatusMessage])

  return (
    <>
      {statusMessage.show && (
        <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
      )}
      <Switch>
        <Route exact path={match.path}>
          <LinksTable links={links} isLoading={isLoading} onNotify={setStatusMessage} />
        </Route>
        <Route
          exact
          path={`${match.path}/new`}
          render={() => <UtmBuilder onSaved={() => history.push('/marketing/utm')} />}
        />
        <Route
          exact
          path={`${match.path}/:id/edit`}
          render={({ match: editMatch }) => (
            <UtmBuilder mode="edit" campaignLinkId={editMatch.params.id} onSaved={() => history.push('/marketing/utm')} />
          )}
        />
        <Route render={() => <Redirect to="/marketing/utm" />} />
      </Switch>
    </>
  )
}

export default withRouter(MarketingLinks)
